import { __assign } from 'tslib';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { FormatLinkOutlineIcon } from '@compono/ui-icons';
import { useEditorContext } from '../EditorContext/EditorContext.js';
import { EditorMenuButton } from '../EditorMenuButton/EditorMenuButton.js';

var EditorLinkButtons = function (_a) {
    var setShowDialog = _a.setShowDialog, showDialog = _a.showDialog, size = _a.size;
    var _b = useEditorContext(), editor = _b.editor, enableFeatures = _b.enableFeatures;
    if (!(enableFeatures === null || enableFeatures === void 0 ? void 0 : enableFeatures.links) || !setShowDialog)
        return null;
    return (jsxs(Fragment, { children: [jsx(EditorMenuButton, __assign({ label: editor.isActive("link") ? "Edit link" : "Add link", onClick: function () { return setShowDialog(!showDialog); }, size: size, commandName: "link" }, { children: jsx(FormatLinkOutlineIcon, {}) })), editor.isActive("link") && (jsx(EditorMenuButton, __assign({ label: "Remove link", onClick: function () { return editor.chain().focus().unsetLink().run(); }, size: size, sx: { color: "critical.80" } }, { children: jsx(FormatLinkOutlineIcon, {}) })))] }));
};

export { EditorLinkButtons };
//# sourceMappingURL=EditorLinkButtons.js.map
